'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var core = require('@material-ui/core');
var styles$4 = require('@material-ui/core/styles');
var icons = require('@material-ui/icons');
var ButtonMaterial = require('@material-ui/core/Button');
var CloseIcon = require('@material-ui/icons/Close');
var HelpOutlineIcon = require('@material-ui/icons/HelpOutline');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var ButtonMaterial__default = /*#__PURE__*/_interopDefaultLegacy(ButtonMaterial);
var CloseIcon__default = /*#__PURE__*/_interopDefaultLegacy(CloseIcon);
var HelpOutlineIcon__default = /*#__PURE__*/_interopDefaultLegacy(HelpOutlineIcon);

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$2 = ".wrapper {\n  padding-left: 1rem;\n  display: flex;\n  position: absolute;\n  align-items: center;\n  width: 100%;\n  height: 96px;\n  left: 0;\n  top: 0; }\n  @media screen and (max-width: 960px) {\n    .wrapper {\n      height: 72px; } }\n\n.header-color {\n  background-color: #163CFF; }\n\n.header-biz-color {\n  background-color: #002863; }\n";
styleInject(css_248z$2);

var img$3 = "data:image/svg+xml,%3csvg width='54' height='43' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M19.434 2.7a.67.67 0 01.175-.03c2.866-.585 6.01-.658 9.49-.03 8.568 1.58 18.248 6.566 21.508 13.306.995 2.062 1.404 4.285.98 6.639a8.177 8.177 0 01-.819 2.325c2.076-3.027 3.392-6.522 2.559-10.03C51.557 7.362 41.834 1.792 32.974.402 21.218-1.439 12.357 3.255 6.815 9.878A23.98 23.98 0 0119.434 2.7zm13.189 34.229s-.015 0 0 0c-9.943 3.684-21.216 4.796-27.693-1.55-1.302-1.272-2.398-2.851-3.261-4.767C.382 27.746.163 24.647.777 21.576a27.26 27.26 0 00-.38 1.77c-.848 4.722-.453 11.039 2.325 14.928 1.491 2.09 3.787 3.89 7.208 4.416 13.7 2.15 29.331-7.487 32.913-9.972 1.39-.965 3.217-2.442 4.972-4.255l-1.477 1.199c-3.597 2.66-8.48 5.322-13.715 7.267z' fill='white' fill-opacity='.5'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M50.61 15.931c.993 2.062 1.388 4.299.979 6.638a8.61 8.61 0 01-.804 2.325c-.878 1.272-1.901 2.471-2.94 3.553l-1.476 1.2c-3.612 2.66-8.48 5.322-13.73 7.266-9.957 3.685-21.23 4.796-27.693-1.55-1.302-1.272-2.398-2.85-3.26-4.766C.383 27.73.178 24.63.792 21.56c1.01-3.991 3.042-8.13 6.024-11.697a24.079 24.079 0 0112.633-7.18.753.753 0 00.161-.028c2.88-.6 6.024-.673 9.49-.03 8.568 1.58 18.248 6.565 21.508 13.306zM34.421 22.48c-.614.512-1.447.775-2.471.775h-1.462v3.29h-1.93V17.2h3.465c.98 0 1.784.264 2.398.79.629.512.936 1.258.936 2.208 0 .994-.307 1.77-.936 2.281zm-2.559-3.436H30.49v2.427h1.389c.863 0 1.55-.395 1.55-1.199-.015-.863-.673-1.228-1.565-1.228zM6.831 26.559h1.93v-3.787h3.919v3.788h1.93v-9.344h-1.93v3.685H8.76v-3.685H6.83v9.343zm10.367-9.343l3.421 5.644h.015v3.7h1.93v-3.788l3.421-5.556h-2.207l-2.179 3.729-2.164-3.729h-2.237zm27.064 1.813v-1.813h-6.111v9.343h6.14v-1.798h-4.24v-2.018h3.773V20.93H40.05v-1.9h4.211z' fill='white'/%3e%3c/svg%3e";

var Header = function (_a) {
    var _b = _a.isBiz, isBiz = _b === void 0 ? false : _b, children = _a.children;
    return (React__default['default'].createElement("div", { className: isBiz ? "header-biz-color wrapper" : "header-color wrapper" },
        React__default['default'].createElement("img", { src: img$3, width: 52, alt: "logo" }),
        children));
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var useStyles$6 = styles$4.makeStyles(function (theme) { return ({
    root: {
        color: theme.hypePalette.stoneBusiness,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 20,
        width: 20,
        zIndex: 1,
        borderRadius: "50%",
        backgroundColor: function (_a) {
            var active = _a.active, completed = _a.completed;
            return active || completed
                ? theme.hypePalette.white
                : theme.hypePalette.stepperConnector;
        },
    },
    circle: {
        width: 8,
        height: 8,
        borderRadius: "50%",
        backgroundColor: "currentColor",
    },
    check: {
        color: "currentColor",
        fontSize: 12,
    },
}); });
var DefaultStepIconComponent = function (_a) {
    var active = _a.active, completed = _a.completed;
    var classes = useStyles$6({ active: active, completed: completed });
    return (React__default['default'].createElement("div", { className: classes.root },
        active && React__default['default'].createElement(icons.Check, { className: classes.check }),
        !active && !completed && React__default['default'].createElement("div", { className: classes.circle })));
};

var styles$3 = function (theme) {
    var _a;
    return ({
        root: {
            width: "100%",
            backgroundColor: "transparent",
        },
        stepRoot: {
            "& $labelActive": {
                opacity: 1,
                fontWeight: 500,
                color: theme.hypePalette.white,
            },
            "& $labelCompleted": {
                opacity: 1,
                fontWeight: 500,
                color: theme.hypePalette.white,
            },
            "& $alternativeLabel": {
                flexDirection: "column-reverse",
            },
        },
        stepHorizontal: {
            padding: 0,
        },
        label: (_a = {
                opacity: 0.5,
                fontSize: theme.fonts.size[14],
                color: theme.hypePalette.white
            },
            _a[theme.breakpoints.down("sm")] = {
                display: "none",
            },
            _a.marginBottom = "16px",
            _a),
        labelActive: {},
        labelCompleted: {},
        labelContainer: {
            "& $alternativeLabel": {
                marginTop: 0,
            },
        },
        alternativeLabel: {},
        connectorAlternativeLabel: {
            top: "unset",
            bottom: 0,
            left: "calc(-50%)",
            right: "calc(50%)",
        },
        connectorActive: {
            "& $connectorLine": {
                borderColor: theme.hypePalette.white,
            },
        },
        connectorCompleted: {
            "& $connectorLine": {
                borderColor: theme.hypePalette.white,
            },
        },
        connectorLine: {
            borderColor: theme.hypePalette.stepperConnector,
            borderTopWidth: 20,
        },
    });
};
var Stepper = function (props) {
    var steps = props.steps, activeStep = props.activeStep, _a = props.StepIconComponent, StepIconComponent = _a === void 0 ? DefaultStepIconComponent : _a, _b = props.classes, classes = _b === void 0 ? {} : _b, other = __rest(props, ["steps", "activeStep", "StepIconComponent", "classes"]);
    var renderStep = function (stepName, index) { return (React__default['default'].createElement(core.Step, { key: index, classes: {
            root: classes.stepRoot,
            horizontal: classes.stepHorizontal,
        } },
        React__default['default'].createElement(core.StepLabel, { classes: {
                label: classes.label,
                active: classes.labelActive,
                completed: classes.labelCompleted,
                labelContainer: classes.labelContainer,
                alternativeLabel: classes.alternativeLabel,
            }, StepIconComponent: StepIconComponent }, stepName))); };
    return (React__default['default'].createElement(core.Stepper, __assign({ alternativeLabel: true, connector: React__default['default'].createElement(core.StepConnector, { classes: {
                alternativeLabel: classes.connectorAlternativeLabel,
                active: classes.connectorActive,
                completed: classes.connectorCompleted,
                line: classes.connectorLine,
            } }), classes: {
            root: classes.root,
        }, activeStep: activeStep }, other), steps.map(renderStep)));
};
var Stepper$1 = styles$4.withStyles(styles$3)(Stepper);

var img$2 = "data:image/svg+xml,%3csvg width='61' height='50' viewBox='0 0 61 50' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M22.2396 4.0189C22.3032 4.00091 22.3682 3.98871 22.434 3.98246C25.653 3.32649 29.1758 3.24146 33.0873 3.94601C42.7079 5.73169 53.4464 11.198 57.1029 18.7659C58.2205 21.0739 58.6818 23.5763 58.1961 26.2123C58.0259 27.099 57.569 27.6384 57.4063 28.8118C59.739 25.4106 61.1963 21.5112 60.261 17.5633C58.2933 9.13295 47.3849 2.88916 37.4361 1.32213C24.2439 -0.742933 14.3074 4.50472 8.08789 11.939C12.2562 8.30642 16.8027 5.18189 22.2396 4.0189V4.0189Z' fill='%23FC766A'/%3e%3cpath d='M1.32108 25.0698C1.15101 25.7379 1.00523 26.4182 0.895907 27.0741C-0.0515943 32.3704 0.385714 39.4645 3.50761 43.8254C5.18395 46.17 7.75922 48.1866 11.5978 48.7817C26.9765 51.1991 44.5175 40.3756 48.5382 37.5938C50.093 36.5127 55.9079 31.5638 57.406 28.8112L1.32108 25.0698Z' fill='%233CCDFF'/%3e%3cpath d='M57.4064 28.8121C57.8442 27.9932 58.1553 27.1126 58.3293 26.2004C58.791 23.5766 58.3417 21.062 57.2361 18.754C53.5676 11.1861 42.7076 5.58619 33.087 3.8248C29.1998 3.1081 25.6649 3.18098 22.4337 3.86124C22.374 3.87805 22.313 3.89024 22.2515 3.89768C16.8135 5.05241 11.8659 7.8614 8.08755 11.9393C4.88907 15.7624 2.57821 20.2472 1.3214 25.0707C0.59817 28.2584 0.749634 31.5586 2.26063 34.791C10.7366 53.5592 47.2559 41.8898 57.4064 28.8121Z' fill='%23163CFF'/%3e%3cpath d='M10.5411 30.1398H8.26953V19.1343H10.5411V23.4709H15.1571V19.1343H17.4287V30.1398H15.1693V25.6817H10.5532V30.1398H10.5411Z' fill='white'/%3e%3cpath d='M23.906 25.7911L19.873 19.1343H22.509L25.06 23.5316L27.6231 19.1343H30.2227L26.1897 25.6817V30.1399H23.9181V25.7789H23.906V25.7911Z' fill='white'/%3e%3cpath d='M39.4187 25.3406C38.6899 25.9479 37.7181 26.2516 36.5033 26.2516H34.7784V30.1267H32.5068V19.1211H36.5883C37.7424 19.1211 38.6899 19.4369 39.4187 20.0564C40.1597 20.6638 40.5242 21.5384 40.5242 22.656C40.5242 23.8221 40.1597 24.7332 39.4187 25.3406ZM36.4062 21.2833H34.7905V24.138H36.4305C37.4508 24.138 38.2526 23.6764 38.2526 22.7289C38.2283 21.7206 37.4508 21.2833 36.4062 21.2833V21.2833Z' fill='white'/%3e%3cpath d='M50.3854 19.1343V21.2722H45.4171V23.5073H49.863V25.6453H45.4171V28.0262H50.4098V30.1398H43.1699V19.1343H50.3854Z' fill='white'/%3e%3c/svg%3e";

var img$1 = "data:image/svg+xml,%3csvg width='33' height='32' viewBox='0 0 33 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M16.5 32C25.3366 32 32.5 24.8366 32.5 16C32.5 7.16344 25.3366 0 16.5 0C7.66344 0 0.5 7.16344 0.5 16C0.5 24.8366 7.66344 32 16.5 32ZM13.6868 16.5604L13.7119 24.5275H17.2798V16.5604H19.8613L21.4547 13.3736H17.2798V11.9091C17.2798 10.9087 17.5576 10.2271 18.9921 10.2271L20.8215 10.2262V7.13612C20.5051 7.09407 19.4191 7 18.1556 7C15.5179 7 13.6868 8.42498 13.6868 11.3819V13.3736H10.5V16.5604H13.6868Z' fill='%23B7BCCC'/%3e%3c/svg%3e";

var img = "data:image/svg+xml,%3csvg width='33' height='32' viewBox='0 0 33 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M16.5 32C25.3366 32 32.5 24.8366 32.5 16C32.5 7.16344 25.3366 0 16.5 0C7.66344 0 0.5 7.16344 0.5 16C0.5 24.8366 7.66344 32 16.5 32ZM23.4 11.325C24.15 11.25 24.825 11.025 25.5 10.725C24.975 11.4 24.375 12.075 23.625 12.6V13.05C23.625 17.925 19.95 23.55 13.125 23.55C11.1 23.55 9.15 22.95 7.5 21.9C7.8 21.975 8.1 21.975 8.4 21.975C10.125 21.975 11.7 21.375 12.975 20.4C11.325 20.4 9.975 19.35 9.525 17.85C9.75 17.925 9.975 17.925 10.2 17.925C10.575 17.925 10.875 17.85 11.175 17.775C9.525 17.475 8.25 15.975 8.25 14.175V14.1C8.7 14.4 9.3 14.55 9.9 14.55C8.925 13.875 8.25 12.75 8.25 11.475C8.25 10.8 8.4 10.2 8.775 9.6C10.575 11.85 13.275 13.35 16.425 13.5C16.35 13.275 16.35 12.975 16.35 12.675V12.675C16.35 10.65 18 9 20.025 9C21.075 9 22.05 9.45 22.725 10.2C23.55 10.05 24.3 9.75 25.05 9.3C24.75 10.125 24.15 10.875 23.4 11.325Z' fill='%23B7BCCC'/%3e%3c/svg%3e";

function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

var useStyles$5 = styles$4.makeStyles(function (theme) {
    var _a;
    return ({
        root: {
            padding: "2.5rem 1.5rem 2rem 1.5rem",
            backgroundColor: "#F5F4F7",
            lineHeight: "22px",
            textAlign: "center",
            color: "#6D7791",
            "& .social": {
                marginRight: "0.25rem",
                marginLeft: "0.25rem",
            },
            "& a": {
                color: "#5A75FF",
                textDecoration: "none",
            },
            "& a, p": (_a = {},
                _a[theme.breakpoints.down("xs")] = {
                    fontSize: "12px !important",
                    lineHeight: "16px",
                },
                _a),
        },
        logo: {
            paddingBottom: "1rem",
        },
    });
});
var Footer = function (props) {
    var className = props.className, domain = props.domain, path = props.path;
    var classes = useStyles$5(props);
    var link = domain + "/" + path;
    return (React__default['default'].createElement("footer", { className: clsx(classes.root, className) },
        React__default['default'].createElement(core.Grid, { justifyContent: "center", container: true },
            React__default['default'].createElement("img", { className: classes.logo, src: img$2, alt: "logo" })),
        React__default['default'].createElement(core.Grid, { justifyContent: "center", container: true },
            React__default['default'].createElement("p", null,
                React__default['default'].createElement("b", null, "Sei al sicuro, \u00E8 HYPE."),
                React__default['default'].createElement("br", null),
                " La tua privacy \u00E8 garantita e i tuoi dati protetti dalla procedura di riconoscimento.",
                React__default['default'].createElement("br", null),
                "Messaggio pubblicitario con finalit\u00E0 promozionale. Per maggiori informazioni leggi",
                " ",
                React__default['default'].createElement("a", { href: "https://www.hype.it/privacy", rel: "noopener noreferrer", target: "_blank" }, "l'Informativa Cookie"),
                " ",
                "e",
                " ",
                React__default['default'].createElement("a", { href: "https://www.hype.it/SSRDocumentDisplayer?dtdPG=PRIVACY_BUSINESS_HYP&dtdPE=1" }, "l'Informativa Privacy."),
                React__default['default'].createElement("br", null),
                "Per tutte le condizioni contrattuali leggere attentamente il",
                " ",
                React__default['default'].createElement("a", { href: link, rel: "noopener noreferrer", target: "_blank" }, "foglio informativo"),
                " ",
                "disponibile su questo sito internet.")),
        React__default['default'].createElement(core.Grid, { justifyContent: "center", container: true },
            React__default['default'].createElement("p", null,
                "\u00A9 2015-2021 - Hype S.p.A. - Piazza Gaudenzio Sella, 1 - 13900 - Biella",
                React__default['default'].createElement("br", null),
                "C.F. 02686590023 - Societ\u00E0 appartenente al Gruppo IVA Maurizio Sella S.A.A. con P. IVA 02675650028 - Numero REA BI/205555 -",
                React__default['default'].createElement("br", null),
                "Societ\u00E0 soggetta all\u2019attivit\u00E0 di direzione e coordinamento di Banca Sella Holding S.p.A. - iscrizione Tribunale di Biella n.71524")),
        React__default['default'].createElement(core.Grid, { justifyContent: "center", container: true },
            React__default['default'].createElement("p", null,
                React__default['default'].createElement("b", null, "Chatta con noi"))),
        React__default['default'].createElement(core.Grid, { justifyContent: "center", container: true },
            React__default['default'].createElement("a", { href: "https://www.facebook.com/Hype.MoneyIsJustaTool?fref=ts", rel: "noopener noreferrer", target: "_blank" },
                React__default['default'].createElement("img", { className: "social", src: img$1, alt: "Facebook" })),
            React__default['default'].createElement("a", { href: "https://twitter.com/Hype_tw", rel: "noopener noreferrer", target: "_blank" },
                React__default['default'].createElement("img", { className: "social", src: img, alt: "Twitter" })))));
};

var useStyles$4 = core.makeStyles({
    root: {
        "& .MuiButton-containedPrimary": {
            color: "#fff",
            backgroundColor: "#284BFF",
        },
        "& .MuiButton-outlinedPrimary": {
            color: "#284BFF",
            border: "2px solid #284BFF",
        },
        "& .MuiButton-containedSecondary": {
            color: "#284BFF",
            backgroundColor: "#fff",
        },
        "& .MuiButton-outlinedSecondary": {
            color: "#fff",
            border: "2px solid #fff",
        },
        "& .Mui-disabled": {
            color: "rgba(0, 0, 0, 0.26)",
            boxShadow: "none",
            backgroundColor: "rgba(0, 0, 0, 0.12)",
            pointerEvents: "initial",
            cursor: "not-allowed",
        },
        "& .MuiButton-outlined.Mui-disabled": {
            border: "2px solid rgba(0, 0, 0, 0.12)",
            backgroundColor: "transparent",
        },
    },
});
var Button = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "primary" : _b, disabled = _a.disabled, fullWidth = _a.fullWidth, href = _a.href, _c = _a.size, size = _c === void 0 ? "medium" : _c, _d = _a.variant, variant = _d === void 0 ? "contained" : _d, label = _a.label, onClick = _a.onClick;
    var buttonStyle = useStyles$4();
    return (React__default['default'].createElement("div", { className: buttonStyle.root },
        React__default['default'].createElement(ButtonMaterial__default['default'], { color: color, disabled: disabled, fullWidth: fullWidth, href: href, size: size, onClick: onClick, variant: variant }, label)));
};

var useStyles$3 = styles$4.makeStyles({
    root: {
        borderRadius: 16,
        backgroundColor: "#f5f4f7",
        boxShadow: "none",
    },
});
var Card = function (_a) {
    var children = _a.children;
    var classes = useStyles$3();
    return (React__default['default'].createElement(core.Card, { className: classes.root },
        React__default['default'].createElement(core.CardContent, null, children)));
};

var styles$2 = function (theme) {
    var _a, _b, _c, _d, _e;
    return ({
        root: {},
        dialogContainer: (_a = {
                alignItems: "flex-end"
            },
            _a[theme.breakpoints.up("md")] = {
                alignItems: "center",
            },
            _a),
        paper: (_b = {
                borderRadius: "16px 16px 0 0",
                height: "auto",
                maxHeight: "50%"
            },
            _b[theme.breakpoints.up("md")] = {
                borderRadius: "16px",
                width: "100%",
            },
            _b),
        containerIconButton: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
        },
        iconButton: (_c = {
                color: theme.hypePalette.stoneLight,
                margin: "12px 12px 6px 12px"
            },
            _c[theme.breakpoints.up("md")] = {
                marginBottom: "30px",
            },
            _c),
        dialogTitle: (_d = {
                padding: "0 24px 24px 24px"
            },
            _d[theme.breakpoints.up("md")] = {
                padding: "0 70px 48px 70px",
            },
            _d),
        spanTitle: {
            color: theme.hypePalette.black,
            fontSize: theme.fonts.size[16],
            fontWeight: 700,
            lineHeight: "24px",
        },
        dialogContent: (_e = {
                fontSize: theme.fonts.size[14],
                color: theme.hypePalette.stoneLight,
                lineHeight: "24px",
                padding: "0 24px 24px 24px"
            },
            _e[theme.breakpoints.up("md")] = {
                padding: "0 70px 70px 70px",
            },
            _e),
    });
};
var Dialog = function (props) {
    var isOpen = props.isOpen, onClose = props.onClose, children = props.children, title = props.title, _a = props.classes, classes = _a === void 0 ? {} : _a, other = __rest(props, ["isOpen", "onClose", "children", "title", "classes"]);
    var theme = styles$4.useTheme();
    var fullScreen = core.useMediaQuery(theme.breakpoints.down("sm"));
    return (React__default['default'].createElement(core.Dialog, __assign({ classes: { root: classes.root, container: classes.dialogContainer }, PaperProps: {
            className: classes.paper,
        }, fullScreen: fullScreen, maxWidth: "md", onClose: onClose, open: isOpen, disableAutoFocus: true, disableEnforceFocus: true }, other),
        React__default['default'].createElement("div", { className: classes.containerIconButton },
            React__default['default'].createElement(core.IconButton, { onClick: onClose, className: classes.iconButton },
                React__default['default'].createElement(CloseIcon__default['default'], null))),
        React__default['default'].createElement(core.DialogTitle, { className: classes.dialogTitle, disableTypography: true },
            React__default['default'].createElement("span", { className: classes.spanTitle }, title)),
        React__default['default'].createElement(core.DialogContent, { className: classes.dialogContent }, children)));
};
var Dialog$1 = styles$4.withStyles(styles$2)(Dialog);

var styles$1 = function (theme) { return ({
    labelContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "8px",
    },
    labelRoot: {
        fontWeight: 700,
        fontSize: theme.fonts.size[12],
        color: theme.hypePalette.stone,
        lineHeight: "16px",
    },
    root: {
        border: "1px solid transparent",
        borderRadius: "8px",
        color: theme.hypePalette.black,
        fontSize: theme.fonts.size[14],
        fontWeight: 700,
        backgroundColor: theme.hypePalette.grayLight,
    },
    input: {
        height: "48px",
        borderRadius: "8px",
        padding: "0 16px",
    },
    focused: {
        border: "1px solid " + theme.hypePalette.blueSpyro,
        backgroundColor: theme.hypePalette.blueSpyroDark,
    },
    error: {
        border: "1px solid " + theme.hypePalette.error,
        backgroundColor: theme.hypePalette.errorDark,
    },
    disabled: {
        cursor: "not-allowed",
    },
    iconButtonHelp: {
        padding: 0,
        color: theme.hypePalette.blueSpyro,
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
    iconButtonPassword: {
        padding: 0,
        color: theme.hypePalette.violetLight,
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
    helperTextRoot: {
        color: theme.hypePalette.stoneLight,
        lineHeight: "22px",
        margin: 0,
        marginTop: "8px",
        fontSize: theme.fonts.size[12],
    },
    helperTextError: {
        color: theme.hypePalette.error,
    },
}); };
var TextField = function (_a) {
    var defaultValue = _a.defaultValue, label = _a.label, onChange = _a.onChange, placeholder = _a.placeholder, required = _a.required, _b = _a.type, type = _b === void 0 ? "text" : _b, disabled = _a.disabled, fullWidth = _a.fullWidth, _c = _a.isOpenDialog, isOpenDialog = _c === void 0 ? false : _c, toggleDialog = _a.toggleDialog, dialogContent = _a.dialogContent, onBlurFromProps = _a.onBlur, _d = _a.hasError, hasError = _d === void 0 ? false : _d, helperText = _a.helperText, input = _a.input, _e = _a.classes, classes = _e === void 0 ? {} : _e;
    var _f = React.useState(false), hasFocus = _f[0], setHasFocus = _f[1];
    var _g = React.useState(false), isVisiblePassword = _g[0], setIsVisiblePassword = _g[1];
    var isPassword = type === "password";
    var onFocus = function () {
        setHasFocus(true);
    };
    var onBlur = function (event) {
        setHasFocus(false);
        if (onBlurFromProps)
            onBlurFromProps(event);
    };
    var togglePassword = function () {
        setIsVisiblePassword(!isVisiblePassword);
    };
    var renderTogglePasswordIcon = function () { return (React__default['default'].createElement(core.IconButton, { onClick: togglePassword, className: classes.iconButtonPassword }, isVisiblePassword ? React__default['default'].createElement(icons.VisibilityOutlined, null) : React__default['default'].createElement(icons.VisibilityOffOutlined, null))); };
    return (React__default['default'].createElement(React__default['default'].Fragment, null,
        dialogContent && (React__default['default'].createElement(Dialog$1, { isOpen: isOpenDialog, title: label, onClose: toggleDialog }, dialogContent)),
        React__default['default'].createElement("div", { className: classes.labelContainer },
            React__default['default'].createElement(core.InputLabel, { classes: { root: classes.labelRoot } }, label),
            dialogContent && (React__default['default'].createElement(core.IconButton, { onClick: toggleDialog, className: classes.iconButtonHelp },
                React__default['default'].createElement(HelpOutlineIcon__default['default'], { fontSize: "small" })))),
        React__default['default'].createElement(core.FormControl, { fullWidth: true, error: hasError },
            React__default['default'].createElement(core.TextField, __assign({}, input, { variant: "filled", color: "primary", placeholder: placeholder, defaultValue: defaultValue, required: required, disabled: disabled, fullWidth: fullWidth, type: isVisiblePassword ? "text" : type, onChange: onChange, InputProps: {
                    disableUnderline: true,
                    endAdornment: isPassword ? renderTogglePasswordIcon() : undefined,
                    classes: {
                        root: classes.root,
                        focused: classes.focused,
                        error: classes.error,
                        input: classes.input,
                        disabled: classes.disabled,
                    },
                }, FormHelperTextProps: {
                    classes: {
                        root: classes.helperTextRoot,
                        error: classes.helperTextError,
                    },
                }, onBlur: onBlur, onFocus: onFocus, error: hasError, helperText: helperText, focused: hasFocus })))));
};
var TextField$1 = styles$4.withStyles(styles$1)(TextField);

var css_248z$1 = ".error > .MuiIconButton-label {\n  color: #c94646; }\n";
styleInject(css_248z$1);

var useStyles$2 = styles$4.makeStyles(function (theme) { return ({
    root: {
        "& .MuiCheckbox-colorPrimary.Mui-checked": {
            color: function (_a) {
                var typePlan = _a.typePlan;
                return typePlan === 'start' ? "#52bef2" : "#284BFF";
            },
        },
        "& .MuiTypography-root": {
            fontSize: "16px !important",
            color: "#505B7D",
            fontWeight: function (_a) {
                var isBold = _a.isBold;
                return isBold ? "bold" : "normal";
            },
            marginTop: 3
        },
        "& .MuiFormHelperText-root": {
            color: "#f44336",
        },
    },
}); });
var Checkbox = function (_a) {
    var isChecked = _a.isChecked, label = _a.label, onChange = _a.onChange, hasError = _a.hasError, helperText = _a.helperText, _b = _a.isBold, isBold = _b === void 0 ? false : _b, _c = _a.typePlan, typePlan = _c === void 0 ? 'biz' : _c;
    var classes = useStyles$2({ isBold: isBold, typePlan: typePlan });
    return (React__default['default'].createElement("div", { className: classes.root },
        React__default['default'].createElement(core.FormControlLabel, { control: React__default['default'].createElement(core.Checkbox, { className: hasError ? 'error' : '', checked: isChecked, onChange: onChange, color: "primary" }), label: label }),
        helperText && React__default['default'].createElement(core.FormHelperText, null, helperText)));
};

var useStyles$1 = styles$4.makeStyles({
    root: {
        "& .MuiRadio-root": {
            color: "#5A75FF",
        },
        "& .Mui-disabled": {
            color: "rgba(0, 0, 0, 0.26)",
            pointerEvents: "initial",
            cursor: "not-allowed",
        },
        "& .MuiFormControlLabel-root": {
            color: "#505B7D",
            marginBottom: "0.5rem",
        },
        "& .MuiFormControl-root": {
            width: "100%",
        },
        "& .MuiFormLabel-root": {
            color: "#505B7D",
            fontSize: "1rem !important",
            marginBottom: "0.5rem",
        },
        "& .MuiFormGroup-root": {
            flexDirection: function (_a) {
                var isHorizontal = _a.isHorizontal;
                return (isHorizontal ? "row" : "column");
            },
        },
    },
});
var Radio = function (_a) {
    var formLabel = _a.formLabel, valueSelected = _a.valueSelected, onChange = _a.onChange, radioList = _a.radioList, _b = _a.isHorizontal, isHorizontal = _b === void 0 ? false : _b;
    var classes = useStyles$1({ isHorizontal: isHorizontal });
    var formLabelRadioGroup = formLabel || undefined;
    var renderRadio = function (radio, index) { return (React__default['default'].createElement(core.Grid, { item: true, xs: isHorizontal ? 6 : 12, key: index },
        React__default['default'].createElement(core.FormControlLabel, { value: radio.value, control: React__default['default'].createElement(core.Radio, null), label: radio.label, disabled: radio.isDisabled }))); };
    return (React__default['default'].createElement("div", { className: classes.root },
        React__default['default'].createElement(core.FormControl, { component: "fieldset" },
            formLabel && React__default['default'].createElement(core.FormLabel, { component: "legend" }, formLabel),
            React__default['default'].createElement(core.Grid, null,
                React__default['default'].createElement(core.RadioGroup, { "aria-label": formLabelRadioGroup, name: formLabelRadioGroup, value: valueSelected, onChange: onChange }, radioList.map(renderRadio))))));
};

var useStyles = core.makeStyles({
    root: {
        top: "calc(50% - 12px)",
        right: 7,
        position: "absolute",
        pointerEvents: "none",
    },
});
var DefaultIconComponent = function () {
    var classes = useStyles();
    var theme = styles$4.useTheme();
    return (React__default['default'].createElement(core.SvgIcon, { className: classes.root },
        React__default['default'].createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.43451 7.4343C3.74693 7.12188 4.25346 7.12188 4.56588 7.4343L12.0002 14.8686L19.4345 7.4343C19.7469 7.12188 20.2535 7.12188 20.5659 7.4343C20.8783 7.74672 20.8783 8.25325 20.5659 8.56567L12.5659 16.5657C12.2535 16.8781 11.7469 16.8781 11.4345 16.5657L3.43451 8.56567C3.12209 8.25325 3.12209 7.74672 3.43451 7.4343Z", fill: theme.hypePalette.stoneLight })));
};

var styles = function (theme) { return ({
    labelContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "8px",
    },
    labelRoot: {
        fontWeight: 700,
        fontSize: theme.fonts.size[12],
        color: theme.hypePalette.stone,
        lineHeight: "16px",
    },
    iconButtonHelp: {
        padding: 0,
        color: theme.hypePalette.blueSpyro,
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
    select: {
        "&&": {
            padding: "0 16px",
        },
    },
    inputRoot: {
        border: "1px solid transparent",
        borderRadius: "8px",
        color: theme.hypePalette.black,
        fontSize: theme.fonts.size[14],
        fontWeight: 700,
        backgroundColor: theme.hypePalette.grayLight,
    },
    input: {
        height: "48px",
        borderRadius: "8px",
        "&:disabled": {
            cursor: "not-allowed",
        },
    },
    focused: {
        border: "1px solid " + theme.hypePalette.blueSpyro,
        backgroundColor: theme.hypePalette.blueSpyroDark,
    },
    error: {
        border: "1px solid " + theme.hypePalette.error,
        backgroundColor: theme.hypePalette.errorDark,
    },
    helperTextRoot: {
        color: theme.hypePalette.stoneLight,
        lineHeight: "22px",
        margin: 0,
        marginTop: "8px",
        fontSize: theme.fonts.size[12],
    },
    helperTextError: {
        color: theme.hypePalette.error,
    },
}); };
var Select = function (_a) {
    var optionList = _a.optionList, label = _a.label, defaultValue = _a.defaultValue, inputFinalForm = _a.inputFinalForm, _b = _a.hasError, hasError = _b === void 0 ? false : _b, helperText = _a.helperText, isDisabled = _a.isDisabled, _c = _a.isOpenDialog, isOpenDialog = _c === void 0 ? false : _c, toggleDialog = _a.toggleDialog, dialogContent = _a.dialogContent, value = _a.value, onChange = _a.onChange, _d = _a.IconComponent, IconComponent = _d === void 0 ? DefaultIconComponent : _d, _e = _a.classes, classes = _e === void 0 ? {} : _e;
    var renderOption = function (option) { return (React__default['default'].createElement("option", { key: option.description, value: option.value }, option.description)); };
    return (React__default['default'].createElement(React__default['default'].Fragment, null,
        dialogContent && (React__default['default'].createElement(Dialog$1, { isOpen: isOpenDialog, title: label, onClose: toggleDialog }, dialogContent)),
        React__default['default'].createElement("div", { className: classes.labelContainer },
            React__default['default'].createElement(core.InputLabel, { classes: { root: classes.labelRoot } }, label),
            dialogContent && (React__default['default'].createElement(core.IconButton, { onClick: toggleDialog, className: classes.iconButtonHelp },
                React__default['default'].createElement(HelpOutlineIcon__default['default'], { fontSize: "small" })))),
        React__default['default'].createElement(core.FormControl, { fullWidth: true, error: hasError },
            React__default['default'].createElement(core.NativeSelect, __assign({}, inputFinalForm, { classes: { root: classes.select }, input: React__default['default'].createElement(core.Input, { classes: {
                        root: classes.inputRoot,
                        focused: classes.focused,
                        error: classes.error,
                        input: classes.input,
                    } }), defaultValue: defaultValue, value: inputFinalForm ? inputFinalForm.value : value, onChange: inputFinalForm ? inputFinalForm.onChange : onChange, disabled: optionList.length === 0 || isDisabled, IconComponent: IconComponent, disableUnderline: true }),
                React__default['default'].createElement("option", { style: { display: "none" }, value: "" }),
                optionList.map(renderOption)),
            helperText && (React__default['default'].createElement(core.FormHelperText, { classes: {
                    root: classes.helperTextRoot,
                    error: classes.helperTextError,
                } }, helperText)))));
};
var Select$1 = styles$4.withStyles(styles)(Select);

var css_248z = ".upload-box-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background: #ffffff;\n  border: 1px dashed #b7bccc;\n  box-sizing: border-box;\n  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  padding: 1.5em;\n  cursor: pointer; }\n\n.image-container {\n  max-height: 130px; }\n\n.box-text {\n  margin-top: 2em;\n  color: #284bff;\n  font-size: 1em !important;\n  font-weight: bold; }\n";
styleInject(css_248z);

var UploadBox = function (_a) {
    var imgUrl = _a.imgUrl, titleBox = _a.titleBox, ref = _a.ref; _a.onChange;
    var thumbnail;
    var showImgUploaded = function (e) {
        // console.log(URL.createObjectURL(e.target.files[0]));
        if (e.target.files) {
            thumbnail = URL.createObjectURL(e.target.files[0]);
            var imgThumb = document.getElementsByClassName("image-container")[0];
            imgThumb.setAttribute("src", thumbnail);
        }
    };
    return (React__default['default'].createElement(React__default['default'].Fragment, null,
        React__default['default'].createElement("input", { id: "file-upload", ref: ref, type: "file", style: { display: "none" }, accept: "image/*", onChange: showImgUploaded }),
        React__default['default'].createElement("label", { htmlFor: "file-upload" },
            React__default['default'].createElement("div", { className: "upload-box-container" },
                React__default['default'].createElement("img", { className: "image-container", src: imgUrl }),
                React__default['default'].createElement("span", { className: "box-text" }, titleBox)))));
};

var theme = styles$4.createTheme({
    hypePalette: {
        black: "#000000",
        white: "#fff",
        stone: "#505B7D",
        stoneLight: "#6D7791",
        grayLight: "#f5f4f7",
        error: "#f44336",
        errorDark: "rgba(255, 77, 61, 0.08)",
        blueSpyro: "#5A75FF",
        blueSpyroDark: "rgba(90, 117, 255, 0.08)",
        violetLight: "#B7BCCC",
        purpleLight: "#bab7cc",
        stoneBusiness: "#002863",
        stepperConnector: "#4c6891",
    },
    props: {
        MuiButtonBase: {
            disableRipple: true,
        },
    },
    typography: {
        fontFamily: [
            "gordita",
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
    },
    fonts: {
        size: {
            30: "30px",
            16: "16px",
            14: "14px",
            12: "12px",
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 768,
            md: 960,
            lg: 1280,
            xl: 1600,
        },
    },
});

exports.Button = Button;
exports.Card = Card;
exports.Checkbox = Checkbox;
exports.Dialog = Dialog$1;
exports.Footer = Footer;
exports.Header = Header;
exports.Radio = Radio;
exports.Select = Select$1;
exports.Stepper = Stepper$1;
exports.TextField = TextField$1;
exports.UploadBox = UploadBox;
exports.theme = theme;
//# sourceMappingURL=index.js.map
